import { apiFetch, ApiError } from '@/lib/api';

// Başvuruların program bazında açık/kapalı durumu — sunucuda tutulur,
// yönetim panelinden değiştirilir.
//
// Bu kontrol YALNIZCA GÖRSELDİR (UX): butonu gizlemek/pasifleştirmek
// kullanıcıya kapalı olduğunu anlatır. Asıl kısıtlama backend'dedir
// (isApplicationOpen); kapalı programa POST gidilirse 403 + { closed: true }
// döner — bkz. isApplicationsClosedError.
export type ApplicationKey = 'community' | 'mentorship' | 'technicalVisit';

export type PublicSettings = {
  // Anahtarların hepsi opsiyonel: backend bir programı hiç yazmamış olabilir.
  // Sözleşme gereği EKSİK ANAHTAR "açık" demektir (backend de böyle davranır).
  applications?: Partial<Record<ApplicationKey, boolean>>;
};

export function getPublicSettings() {
  return apiFetch<PublicSettings>('/api/public/settings');
}

// Site içi başvuru rotası → program anahtarı. programs.ts'teki `applyTo`
// alanları bu rotalardan birini gösterir; buradaki eşleme sayesinde genel
// program detay sayfası da hangi programın durumuna bakacağını bilir.
const APPLICATION_ROUTES: Record<string, ApplicationKey> = {
  '/mentorship': 'mentorship',
  // Eklem ve Teknik Gezi BURADA YOK: başvuruları panelden yönetilen forma
  // taşındı; açık olup olmadığını formun yayın durumu belirler
  // (bkz. useProgramApplication). Burada yalnız koda gömülü akışlar kalır.
};

// Program detay sayfası (/program/<slug>) → başvuru anahtarı. Program kartları
// bu sayfalara bağlanır; "Başvurular Açık" rozetinin doğru olması için karta
// da hangi başvurunun geçerli olduğunu söylemek gerekir.
const PROGRAM_SLUG_APPLICATIONS: Record<string, ApplicationKey> = {
  'mentor-pool': 'mentorship',
};

/**
 * Bir site içi hedefin (rota) hangi başvuruya karşılık geldiğini bulur.
 *
 * Eşleşmeyen hedef → undefined, yani "kapatılabilir bir başvuru değil":
 * CTA/rozet her zaman açık gösterilir.
 */
export function applicationKeyForRoute(
  route: string | undefined,
): ApplicationKey | undefined {
  if (!route) return undefined;
  // Query VE hash atılır ('/mentorship#basvuru' de eşleşsin), sondaki slash
  // normalize edilir.
  const path = route.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  const direct = APPLICATION_ROUTES[path];
  if (direct) return direct;
  const program = /^\/program\/([a-z0-9-]+)$/.exec(path);
  return program ? PROGRAM_SLUG_APPLICATIONS[program[1]] : undefined;
}

// Kapalı programa gönderim denemesinin backend yanıtı: HTTP 403 + { closed: true }.
// Genel "bir hata oluştu" mesajı yerine özel mesaj göstermek için kullanılır.
export function isApplicationsClosedError(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    err.status === 403 &&
    typeof err.data === 'object' &&
    err.data !== null &&
    (err.data as { closed?: unknown }).closed === true
  );
}
